<template>
  <div id="root_box">
    <div id="dplayer" @click="clickAction"></div>
    <div class="play-icon-box">
      <svg :style="{display: isPlaying ? 'none' : ''}" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 16 32"><path style="fill: #fff" d="M15.552 15.168q0.448 0.32 0.448 0.832 0 0.448-0.448 0.768l-13.696 8.512q-0.768 0.512-1.312 0.192t-0.544-1.28v-16.448q0-0.96 0.544-1.28t1.312 0.192z"></path></svg>
    </div>
    <div class="absolute-box" v-if="geted">
      <div class="row" v-if="isPlan">
        <el-image class="avatar"
          :src="avatar">
          <div slot="error" class="image-slot"></div>
        </el-image>
        <span class="study">我已学习</span>
        <span class="days">{{days}}</span>
        <span class="study">天</span>
      </div>
      <div class="row" v-else>
        <el-image class="avatar"
          :src="avatar">
          <div slot="error" class="image-slot"></div>
        </el-image>
        <span class="study">我正在学习</span>
        <span class="course">《{{courseName}}》</span>
        <span class="study"></span>
      </div>
      <div class="btn-box" v-if="configed">
        <div class="btn-goto">去天天学拍，拍同款</div>
        <div class="btn-wx-box">
          <wx-open-launch-app
            id="launch-btn"
            appid="wx6612705805e162b2"
            @error="handleError"
            @launch="handleLaunch"
            :extinfo="extinfo"
          >
            <script type="text/wxtag-template">
              <style>
                .btn-goto-app {
                  line-height: 44px !important;
                  height: 44px !important;
                  width: 1000px !important;
                  background-color: rgba(0, 0, 0, 0);
                  color: #FFFFFF;
                  font-size: 16px;
                  font-weight: bold;
                  border-radius: 22px;
                  opacity: 1;
                }
              </style>
              <div class="btn-goto-app"></div>
            </script>
          </wx-open-launch-app>
        </div>
      </div>
      <!-- <div class="btn-box" v-else-if="isIOS">
        <div class="btn-goto" @click="gotoApp">去天天学拍，拍同款</div>
      </div> -->
      <div class="btn-box" v-else>
        <!-- <div class="btn-goto">去天天学拍，拍同款</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import DPlayer from 'dplayer'
import ApiQuestion from '@/apis/apiQuestion.js'
const jweixin = require("weixin-js-sdk");
export default {
  data() {
    return {
      configed: false,
      videoUrl: null,
      videoImage: null,
      avatar: null,
      days: 0,
      geted: false, // 拿到接口数据
      isPlan: false, // 是否打卡计划
      courseName: null,
      dp: null,
      isPlaying: false,
      extinfoMap: {
        openType: 'player',
      },
      extinfo: "{}",
      isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      shareTitle: "",
      shareDesc: "",
      shareImgUrl: "",
    }
  },
  methods: {
    clickAction() {
      console.log('clickAction')
      this.dp.toggle()
    },
    gotoApp() {
      window.location.href = "https://ttxp.zxyq360.com?extmsg=" + this.extinfo
    },
    handleError(e) {
      alert('APP未安装，应用宝微下载配置后，进行下载')
      // alert(JSON.stringify(e))
    },
    handleLaunch(e) {
      // alert('handleLaunch')
      // alert(JSON.stringify(e))
    },
  },
  mounted() {
    console.log(this.$route.query)
    //
    //dp是播放器对象
    // this.dp.on('playing', function () {
    //   setTimeout(function(){ 
    //     document.getElementById("dplayer").classList.add("dplayer-hide-controller");
    //   }, 0);
    // });
    ApiQuestion.getVideo({
      videoId: this.$route.query.videoId,
      url: location.href
    }).then(res => {
      if (res.code === 0) {
        this.geted = true
        this.isPlan = res.data.video.courseType == "COURSE4PLAN"
        this.courseName = res.data.video.courseName
        this.days = res.data.clockDays
        this.avatar = res.data.user.avatar
        this.extinfoMap.video = res.data.video
        this.extinfo = JSON.stringify(this.extinfoMap)
        document.title = res.data.video.courseName
        this.shareTitle = "我正在打卡《" + res.data.video.courseName + "》"
        this.shareDesc = "快来天天学拍一起打卡学习！"
        this.shareImgUrl = res.data.video.videoImage
        var config = res.data.config
        jweixin.config({
          // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: config.appId, // 必填，公众号的唯一标识
          timestamp: config.timestamp, // 必填，生成签名的时间戳
          nonceStr: config.nonceStr, // 必填，生成签名的随机串
          signature: config.signature, // 必填，签名
          jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表
          openTagList: ["wx-open-launch-app"], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        });
        jweixin.ready((res) => {
          this.configed = true
          console.log("wx-open-launch-app已加载============>");
          jweixin.onMenuShareTimeline({
            title: this.shareTitle, // 分享标题
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: this.shareImgUrl, // 分享图标
          });
          jweixin.onMenuShareAppMessage({
            link: location.href,
            title: this.shareTitle, // 分享标题
            desc: this.shareDesc, // 分享描述
            imgUrl: this.shareImgUrl, // 分享图标
          });
        });
        var video = res.data.video
        this.dp = new DPlayer({
          container: document.getElementById('dplayer'),
          autoplay: true,
          video: {
            url: video.videoUrl,
            pic: video.videoImage,
          },
        });
        this.dp.on('play', () => {
          this.isPlaying = true
        });
        this.dp.on('pause', () => {
          this.isPlaying = false
        });
      } else {
        //
      }
    }).catch(err => {
      //
    })
  }
}
</script>

<style lang="scss" scoped>
  .match-parent {
    width: 100%;
  }
  #root_box {
    height: 100%;
    background-color: #000000;
  }
  #dplayer {
    height: 100%;
  }
  .play-icon-box {
    width: 50px;
    height: 50px;
    border: none;
    background-color: transparent;
    outline: none;
    box-sizing: border-box;
    bottom: 0;
    opacity: 0.8;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -100%);
    pointer-events: none;
  }
  .absolute-box {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
  /deep/.dplayer.dplayer-mobile .dplayer-mobile-play {
    display: none;
  }
  /deep/.dplayer-controller {
    display: none;
  }
  /deep/.dplayer-controller-mask {
    display: none;
  }
  /deep/.el-button--success {
    color: #000000;
    background-color: #28C76D;
    border-color: #28C76D;
  }
  .btn-box {
    width: 90%;
    height: 44px;
    margin-left: 5%;
    margin-right: 5%;
    margin-bottom: 36px;
    position: relative;
  }
  .btn-goto {
    line-height: 44px;
    width: 100%;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: bold;
    background: linear-gradient(270deg, #15D267 0%, #28C76D 100%);
    border-radius: 22px;
    opacity: 1;
    text-align: center;
  }
  .btn-wx-box {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
  }
  .row {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
    margin-bottom: 14px;
    font-size: 0; // img的5px
  }
  .avatar {
    width: 28px;
    height: 28px;
    border: 2px solid #FFFFFF;
    border-radius: 15px;
    background-color: #D9D9D9;
    margin-right: 10px;
  }
  .study {
    vertical-align: bottom;
    line-height: 26px;
    font-size: 14px;
    font-weight: bold;
    color: #FFFFFF;
  }
  .days {
    vertical-align: bottom;
    line-height: 32px;
    font-size: 27px;
    font-weight: bold;
    color: #17D067;
    margin: 0px 2px 0px 2px;
  }
  .course {
    vertical-align: bottom;
    line-height: 26px;
    font-size: 14px;
    font-weight: bold;
    color: #17D067;
    margin: 0px 2px 0px 2px;
  }
</style>
